import { Text, View } from '@react-pdf/renderer';

import { PDFQuoteLineType, usePDFContext } from '../../../PDFProvider';
import { formatLineNumber } from '../../utils/format-line-number';
import { styles } from '../styles';
import { PartInformation } from './PartInformation';
import { QuoteLineDetails } from './QuoteLineDetails';

type QuoteLineProps = PDFQuoteLineType & {
  showDrawing?: boolean;
  children: React.ReactNode;
  bottomOfLineText?: string;
};

export function QuoteLine({
  bottomOfLineText,
  lineNumber,
  children,
  leadTime,
  leadTimeNotes,
  part,
  quotePrices,
  showDrawing = false,
}: QuoteLineProps) {
  const { pricingUnit, leadTimeFormat } = usePDFContext();

  return (
    <View style={[styles.gap10, styles.column, styles.wrapper]}>
      <View style={[styles.gap10, styles.row]}>
        <View style={styles.column}>
          <Text>Line Number {formatLineNumber(lineNumber)}</Text>
        </View>

        <PartInformation>{children}</PartInformation>

        <View style={[styles.column, styles.leftColumnWrapper]}>
          <QuoteLineDetails
            drawingId={part.drawingId}
            drawingRevision={part.drawingRevision}
            leadTime={leadTime}
            leadTimeNotes={leadTimeNotes}
            leadTimeFormat={leadTimeFormat}
            showDrawing={showDrawing}
          />

          <View
            style={[
              styles.gap10,
              styles.row,
              styles.widthFull,
              { justifyContent: 'space-between' },
            ]}
          >
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>Quantity</Text>
              {quotePrices.map(({ id, quantity }) => (
                <Text key={`${id}-${quantity}`}>{quantity}</Text>
              ))}
            </View>
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>{pricingUnit}</Text>
              {quotePrices.map(({ id, unitPrice }) => (
                <Text key={`${id}-${unitPrice}`}>{unitPrice}</Text>
              ))}
            </View>
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>Line Total</Text>
              {quotePrices.map(({ id, total }) => (
                <Text key={`${id}-${total}`}>{total}</Text>
              ))}
            </View>
          </View>
        </View>
      </View>

      {bottomOfLineText && (
        <View style={[styles.gap10, styles.row]}>
          <Text style={styles.textSmall}>{bottomOfLineText}</Text>
        </View>
      )}
    </View>
  );
}
